export const buildUpdateEventData = (data) => {
  return {
    ...data,
    platformMaterial:
      data.platformMaterial === 'other'
        ? data.platformOtherMaterial
        : data.platformMaterial
  };
};
